import { useEffect } from "react";

// Loads the global body rule; the module exports no classes we use.
import "./hideIntercom.module.scss";

const BODY_CLASS = "ui2026HideIntercom";
// Several overlays can be open at once; Intercom returns when the last closes.
let openCount = 0;

/**
 * Hide the Intercom launcher while ``active`` (CSS only — per-user Intercom
 * settings are left alone).
 */
export const useHideIntercom = (active: boolean) => {
  useEffect(() => {
    if (!active) return;
    openCount += 1;
    document.body.classList.add(BODY_CLASS);
    return () => {
      openCount = Math.max(0, openCount - 1);
      if (openCount === 0) document.body.classList.remove(BODY_CLASS);
    };
  }, [active]);
};
